import type { ReviewableInput } from "ui/widgets/Input";
import type { ReviewableFormInputProps } from "../types";
import { useConfigContext } from "../providers";

export const useFieldsComments = ({
    setFieldValue,
    setFieldTouched,
    values,
    name
}: Pick<
    ReviewableFormInputProps,
    | 'setFieldValue'
    | 'setFieldTouched'
    | 'values'
    | 'name'
>) => {
    const config = useConfigContext();

    const onApplyFieldReason = ({ notes }: ReviewableInput.Reason) => {
        setFieldValue(
            config.FieldsComments,
            {
                ...values[config.FieldsComments],
                [name]: {
                    ...values[config.FieldsComments]?.[name],
                    reason: notes
                }
            }
        );

        setTimeout(() => setFieldTouched(config.FieldsComments, true, true));
    };

    return {
        onApplyFieldReason
    };
};

export default useFieldsComments;
